import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  formatReestr,
  getDefaultAlertProps,
  getFormTypesSpan,
  getIdFromArray,
  getIdFromArrayWithFifoei,
  getIvkPreobrType,
  getModelFromMany,
  getNameArray,
  getNameArrayWithFifoei,
  getNameFromArray,
  getNameFromArrayWithFifoei,
  getUnitType,
} from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { MyButton } from '../UI/MyButton';
import { IAlertProps } from '../../interface/IAlertProps';
import { IApiResult } from '../../interface/IApiResult';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import {
  API_STATUS_PROBLEM,
  MAIN_COLOR_STRING,
  PR_TYPE,
  SI_TYPE_ALL,
  SI_TYPE_FLOW,
  SI_TYPE_IVK_ONLY_CALC,
} from '../../constant/constants';
import { MyAutoComplete } from '../UI/MuAutoComplete';
import { SpanListDto } from '../../dto/span/SpanLIstDto';
import { apiAddSpan } from '../../service/span/apiAddSpan';
import { MyTextFiled } from '../UI/MyTextField';
import { MyCheckBox } from '../UI/MyCheckBox';
import { apiGetReestr } from '../../service/device/apiGetReestr';
import { DeviceListDto } from '../../dto/DeviceListDto';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const DialogCreateSpan: FunctionComponent<Props> = ({
  open,
  onClose,
}) => {
  const { parSiId, parModelId, parPodModelId } = useParams();
  const [checkHelper, setCheckHelper] = useState(false);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  const preobrTypes = getIvkPreobrType();
  const formTypes = getFormTypesSpan();
  const [spanDto, setSpanDto] = useState<SpanListDto>({
    id: -1,
    siId: parseInt(parSiId ?? '-1', 10),
    modelId: parseInt(parModelId ?? '-1', 10),
    note: '',
    npi: '',
    perehod: '',
    vpi: '',
    unit: -1,
    isForm: -1,
    formType: -1,
    ivkSpanType: -1,
    isReestr: -1,
    reestrId: -1,
  });

  const [deviceDtos, setDeviceDtos] = useState<DeviceListDto[]>([]);
  const [device2Dtos, setDevice2Dtos] = useState<DeviceListDto[]>([]);

  const curTypeSi = parseInt(localStorage.getItem(PR_TYPE) ?? '-1', 10);

  const units = getUnitType(
    curTypeSi !== SI_TYPE_IVK_ONLY_CALC ? curTypeSi : spanDto.ivkSpanType
  );

  const getDevices = async () => {
    if (
      parseInt(localStorage.getItem(PR_TYPE) ?? '-1', 10) !==
      SI_TYPE_IVK_ONLY_CALC
    ) {
      return;
    }
    const apiResult: IApiResult = await apiGetReestr('', '');
    if (apiResult.isSuccess) {
      setDeviceDtos(apiResult.data.reestr);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const formatDevices = () => {
    setDevice2Dtos(formatReestr(deviceDtos, spanDto.ivkSpanType));
  };

  const handleClose = () => {
    setSpanDto({
      id: -1,
      siId: parseInt(parSiId ?? '-1', 10),
      modelId: getModelFromMany(parModelId, parPodModelId),
      note: '',
      npi: '',
      perehod: '',
      vpi: '',
      unit: -1,
      isForm: -1,
      formType: -1,
      ivkSpanType: -1,
      isReestr: -1,
      reestrId: -1,
    });
    onClose();
    setCheckHelper(false);
  };

  const addSpan = async () => {
    const apiResult: IApiResult = await apiAddSpan(spanDto);
    if (apiResult.isSuccess) {
      handleClose();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const handleAdd = async () => {
    if (
      (spanDto.npi === '' || spanDto.vpi === '' || spanDto.unit === -1) &&
      spanDto.isForm !== 1 &&
      spanDto.isReestr !== 1
    ) {
      setCheckHelper(true);
      return;
    }
    await addSpan();
  };

  useEffect(() => {
    if (open) {
      getDevices();
      setSpanDto({
        id: -1,
        siId: parseInt(parSiId ?? '-1', 10),
        modelId: getModelFromMany(parModelId, parPodModelId),
        note: '',
        npi: '',
        perehod: '',
        vpi: '',
        unit: -1,
        isForm: -1,
        formType: -1,
        ivkSpanType: -1,
        isReestr: -1,
        reestrId: -1,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (spanDto.ivkSpanType !== -1) {
      formatDevices();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spanDto.ivkSpanType]);

  return (
    <div>
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Dialog
        open={open}
        fullWidth
        maxWidth="sm"
        style={{ userSelect: 'none' }}
        PaperProps={{
          sx: { backgroundColor: '#e7ebee', width: '100%', height: '550px' },
        }}
      >
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography
                style={{
                  fontFamily: 'sans-serif',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  fontSize: '24px',
                  letterSpacing: 1,
                  color: '#000000',
                }}
                component="text"
              >
                Диапазон измерений
              </Typography>
            </Stack>
            <IconButton size="medium" onClick={() => handleClose()}>
              <CloseIcon fontSize="medium" sx={{ color: MAIN_COLOR_STRING }} />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent style={{ padding: '20px' }}>
          <Stack spacing={2} height="100%" justifyContent="space-between">
            <Stack width="100%" direction="column" spacing={1}>
              <MyTextFiled
                value={spanDto.note}
                onChange={(e) =>
                  setSpanDto({
                    ...spanDto,
                    note: e.target.value,
                  })
                }
                type="text"
                label="Примечание (исполнение)"
                size="small"
              />
              {curTypeSi === SI_TYPE_IVK_ONLY_CALC && (
                <MyCheckBox
                  value={spanDto.isReestr === 1}
                  onChange={(e) => {
                    setSpanDto({
                      ...spanDto,
                      isReestr: e.target.checked ? 1 : 0,
                    });
                  }}
                  label="Выбрать из реестра"
                />
              )}
              {curTypeSi === SI_TYPE_IVK_ONLY_CALC && (
                <MyAutoComplete
                  value={
                    spanDto.ivkSpanType !== undefined &&
                    spanDto.ivkSpanType !== -1
                      ? getNameFromArray(preobrTypes, spanDto.ivkSpanType)
                      : ''
                  }
                  onChange={(e, v) =>
                    setSpanDto({
                      ...spanDto,
                      ivkSpanType: getIdFromArray(preobrTypes, v),
                    })
                  }
                  error={checkHelper}
                  arrayList={getNameArray(preobrTypes)}
                  size="small"
                  maxHeightDropList="500px"
                  label="Измеряемый параметр"
                />
              )}
              {spanDto.isReestr === 1 && (
                <MyAutoComplete
                  value={
                    spanDto.reestrId !== undefined && spanDto.reestrId !== -1
                      ? getNameFromArrayWithFifoei(
                          device2Dtos,
                          spanDto.reestrId
                        )
                      : ''
                  }
                  onChange={(e, v) =>
                    setSpanDto({
                      ...spanDto,
                      reestrId: getIdFromArrayWithFifoei(device2Dtos, v),
                    })
                  }
                  error={checkHelper}
                  arrayList={getNameArrayWithFifoei(device2Dtos)}
                  size="small"
                  maxHeightDropList="500px"
                  label="Реестр"
                />
              )}
              {spanDto.isReestr !== 1 && (
                <Stack width="100%" direction="column" spacing={1}>
                  {spanDto.isForm !== 1 && (
                    <MyAutoComplete
                      value={
                        spanDto.unit !== undefined && spanDto.unit !== -1
                          ? getNameFromArray(units, spanDto.unit)
                          : ''
                      }
                      onChange={(e, v) =>
                        setSpanDto({
                          ...spanDto,
                          unit: getIdFromArray(units, v),
                        })
                      }
                      error={checkHelper}
                      arrayList={getNameArray(units)}
                      size="small"
                      maxHeightDropList="500px"
                      label="Единица измерений"
                    />
                  )}
                  {spanDto.isForm !== 1 && (
                    <MyTextFiled
                      value={spanDto.npi}
                      onChange={(e) =>
                        setSpanDto({
                          ...spanDto,
                          npi: e.target.value,
                        })
                      }
                      error={checkHelper}
                      type="number"
                      label="Нижний предел измерений"
                      size="small"
                    />
                  )}
                  {spanDto.isForm !== 1 && curTypeSi === SI_TYPE_FLOW && (
                    <MyTextFiled
                      value={spanDto.perehod}
                      onChange={(e) =>
                        setSpanDto({
                          ...spanDto,
                          perehod: e.target.value,
                        })
                      }
                      error={checkHelper}
                      type="text"
                      label="Переходная точка (через ;) (при наличии)"
                      size="small"
                    />
                  )}
                  {spanDto.isForm !== 1 && (
                    <MyTextFiled
                      value={spanDto.vpi}
                      onChange={(e) =>
                        setSpanDto({
                          ...spanDto,
                          vpi: e.target.value,
                        })
                      }
                      error={checkHelper}
                      type="number"
                      label="Верхний предел измерений"
                      size="small"
                    />
                  )}
                  <MyCheckBox
                    value={spanDto.isForm === 1}
                    onChange={(e) => {
                      setSpanDto({
                        ...spanDto,
                        isForm: e.target.checked ? 1 : 0,
                      });
                    }}
                    label="В виде формулы"
                  />
                  {spanDto.isForm === 1 && (
                    <MyAutoComplete
                      value={
                        spanDto.formType !== undefined &&
                        spanDto.formType !== -1
                          ? getNameFromArray(formTypes, spanDto.formType)
                          : ''
                      }
                      onChange={(e, v) => {
                        setSpanDto({
                          ...spanDto,
                          formType: getIdFromArray(formTypes, v),
                        });
                      }}
                      error={checkHelper}
                      arrayList={getNameArray(formTypes)}
                      size="small"
                      label="Тип формулы"
                    />
                  )}
                </Stack>
              )}
            </Stack>

            <MyButton
              text="Добавить"
              background={MAIN_COLOR_STRING}
              onClick={handleAdd}
            />
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
};
